import React, { FC, ReactNode } from 'react';
import { Environment } from 'react-relay';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = (): Promise<ReactNode> => {
    return import(
        /* webpackChunkName: "PdpSharedReturnModalWrapper" */
        './PdpSharedReturnModalWrapper'
    ).then(({ PdpSharedReturnModalWrapper }) => PdpSharedReturnModalWrapper);
};

type Props = {
    itemId: string;
    userId?: string;
    environment: Environment;

    isOpen: boolean;
    onClose: () => void;
};

const PdpSharedReturnModalLoader: FC<Props> = props => {
    return <ComponentLoader {...props} load={props.isOpen} importFunc={importFunc} />;
};

export { PdpSharedReturnModalLoader };
